let utils = require('../../utils')

export default {
  name: 'es-mycard-like-list',
  data: () => ({
    likeUserList: [],
    authToken: '',
    timeStamp: '',
    searchEnd: false,
    nextExist: false,
    currentPage: 0
  }),
  created: function () {
    this.getLikeUserList(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.getLikeUserList, true, 'button.next-page-search-btn')
  },
  computed: {
    getUserImage () {
      return imagePath => {
        if (imagePath) {
          return `${imagePath}?token=${localStorage.access_token}&timestamp=${this.timeStamp}`
        }
        return require('../images/img_profile.png')
      }
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  methods: {
    goBack: function () {
      if (window.sessionStorage.getItem('es_mycard_like_list_referrer')) {
        const referrer = window.sessionStorage.getItem('es_mycard_like_list_referrer')
        this.$router.push({ path: referrer})
      } else {
        this.$router.go(-1)
      }
    },
    goProfileDetail: function (userId) {
      window.sessionStorage.setItem('profile_detail_referrer', this.$router.history.current.path)
      this.$router.push({ path: '/profile/' + userId })
    },
    async getLikeUserList (addSearch) {
      let data = {
        card_id: this.$route.params.es_mycard_id
      }
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }

      const res = await this.$store.dispatch('CARD_LIKE_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })

      if (addSearch) {
        this.likeUserList = this.likeUserList.concat(res.card_likes)
      } else {
        this.likeUserList = res.card_likes
        this.searchEnd = true
      }
      this.nextExist = res.next_exist
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/es-mycard-like-list.js